import Axios from "axios";
import {
    SET_SECONDARY_UNIT_LIST,
    UNSET_SECONDARY_UNIT_LIST,
  } from "@/store/mutation-types";
import { getSecondaryUnitList, saveUpdateSecondaryUnit } from "@/store/api";
// initial state
const state = {
  getSecondaryUnitList: [],
};

const getters = {
  getSecondaryUnitList(state) {
    return state.getSecondaryUnitList;
  },
};

const mutations = {
  [SET_SECONDARY_UNIT_LIST](state, data) {
    state.getSecondaryUnitList = data;
  },
  [UNSET_SECONDARY_UNIT_LIST](state) {
    state.getSecondaryUnitList = [];
  }
};

const actions = {

  saveUpdateSecondaryUnit({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSecondaryUnit, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getSecondaryUnitList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSecondaryUnitList, data)
        .then(function (response) {
          commit('SET_SECONDARY_UNIT_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SECONDARY_UNIT_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  }, 
};

export default {
  state,
  getters,
  actions,
  mutations,
};
